import React from 'react';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';
import PageBanner from '../components/PageBanner';
import ServiceSidebar from '../components/ServiceSidebar';
import ServiceContactForm from '../components/ServiceContactForm';
import { SRLWrapper } from 'simple-react-lightbox';
import img1 from '../assets/img/gallery/5.jpg';
import img2 from '../assets/img/gallery/6.jpg';
import FaqAccordion from '../components/FaqAccordion';

function IndustrialEquipmentService() {
    const bannerBg = '/service-hero-bg.jpg';

    return (
        <>
            <Header1 />
            <PageBanner
                bannerBg={bannerBg}
                heading="Industrial Equipment & Machine Design"
                currentPage="Industrial Equipment & Machine Design"
            />
            <section className="service-details-wrapper section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-4 mt-5 mt-md-0 col-12 order-2 order-md-1">
                            <ServiceSidebar />
                        </div>
                        <div className="col-lg-9 col-md-8 col-12 order-1 order-md-2">
                            <div className="service-details-content-wrapper pl-0 pl-md-4">
                                <h2>Custom Industrial Equipment Solutions</h2>
                                <p>
                                    ProtoPath specialises in designing and manufacturing custom industrial equipment tailored to your
                                    unique operational requirements. From specialised pumping systems to automated material handling
                                    solutions, we engineer robust equipment that enhances productivity and reliability in demanding
                                    industrial environments across Australia.
                                </p>

                                <h2>Custom Pumping Equipment & Conveyors</h2>
                                <p>
                                    Our expertise includes designing custom pumping equipment for oil, grease, and other fluids, ensuring
                                    precise flow control and reliable operation. We also create custom conveyor systems engineered for
                                    your specific products and production processes. Whether you need capping machines, bowl feeders,
                                    or specialized conveyor configurations, our solutions optimize throughput while maintaining product
                                    integrity and operational efficiency.
                                </p>

                                {/* <SRLWrapper>
                                    <div className="row">
                                        <div className="col-md-6 col-12">
                                            <a href={img1} className="popup-gallery">
                                                <img src={img1} alt="Capping Machines & Bowl Feeders" />
                                            </a>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <a href={img2} className="popup-gallery">
                                                <img src={img2} alt="Custom Conveyors & Stillages" />
                                            </a>
                                        </div>
                                    </div>
                                </SRLWrapper> */}

                                <h2>Material Handling & Custom Stillages</h2>
                                <p>
                                    We design and manufacture specialised material handling equipment for lifting and moving large,
                                    heavy loads safely and efficiently. Our custom stillages and industrial storage solutions are
                                    engineered to your exact specifications, ensuring optimal space utilization and load security.
                                    These solutions integrate seamlessly with your existing production workflows, reducing handling
                                    time and minimizing the risk of product damage during transport and storage.
                                </p>

                                <blockquote>
                                    Transform your production capabilities with custom-engineered industrial equipment designed
                                    specifically for your operational challenges and workflow requirements.
                                </blockquote>

                                <div className="faq-content pl-0 pl-md-4 mt-5">
                                    <h2>Equipment Categories</h2>
                                    <FaqAccordion
                                        question="Custom Pumping & Fluid Handling"
                                        answer="Specialised pumping equipment for oil, grease, and various fluids with precise flow control, including capping machines and automated dispensing systems for manufacturing applications."
                                    />
                                    <FaqAccordion
                                        question="Conveyor Systems & Automation"
                                        answer="Custom-designed conveyor systems including bowl feeders and specialized transport solutions optimized for your specific products, production rates, and facility layout."
                                    />
                                    <FaqAccordion
                                        question="Material Handling Equipment"
                                        answer="Heavy-duty lifting and moving equipment designed for large loads, including custom stillages and industrial storage solutions engineered for safety, efficiency, and durability."
                                    />
                                </div>

                                <ServiceContactForm serviceName="Industrial Equipment & Machine Design" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer1 />
        </>
    );
}

export default IndustrialEquipmentService;
